import { downloadBlob, pickAndReadFile } from './browserFileIO';
import type { ProjectDto } from '@/schemas/chip';
import { latestProjectBytes } from '@/services/automaticProjectMigration';
import {
  CURRENT_PROJECT_EXTENSION,
  CURRENT_PROJECT_MIME,
  decodeCurrentProjectDto,
} from '@/services/projectSnapshot/CurrentProjectFormat';

/** Import supported releases through the same validated migration as stored projects. */
export async function readCurrentProjectFile(file: Blob): Promise<ProjectDto> {
  return decodeCurrentProjectDto(await latestProjectBytes(file));
}

export function pickCurrentProjectFile(): Promise<ProjectDto | null> {
  // Older JSON files upgrade automatically; the selected file remains unchanged.
  return pickAndReadFile(
    `${CURRENT_PROJECT_EXTENSION},${CURRENT_PROJECT_MIME},.json,application/json`,
    readCurrentProjectFile,
  );
}

export function downloadProjectFile(blob: Blob, name: string): void {
  downloadBlob(blob, `${name}${CURRENT_PROJECT_EXTENSION}`);
}
